import axios from '../config/axios';

export async function deleteEntry(entryId, token) {
  const response = await axios.delete(`/userdatad/${entryId}`, {
    headers: { Authorization: `Bearer ${token}` },
  });

  return response.data;
}
